import React from 'react';
import { Link } from 'carbon-components-react';

const Password: React.FC<Props> = ({ isEnterpriseAdmin }) => {
  return (
    <div id="pageDirectory" className="page-directory spacing-padding">
      <div className="directory-title">On this page</div>
      <div className="user-details">
        <div className="link-rows">
          <Link href="#internalUser" className="directory-link">
            Internal users
          </Link>
        </div>
        <div className="link-rows">
          <Link href="#gisViewersAnchor" className="directory-link">
            GIS viewer access
          </Link>
        </div>
        <div className="link-rows">
          <Link href="#gisFeatureLayersAnchor" className="directory-link">
            GIS feature layers
          </Link>
        </div>
        <div className="link-rows">
          <Link href="#sharingEnquiriesAnchor" className="directory-link">
            Sharing enquiries
          </Link>
        </div>
        {isEnterpriseAdmin && (
          <div className="link-rows">
            <Link href="#identityIntegration" className="directory-link">
              Identity integration
            </Link>
          </div>
        )}
        <div className="link-rows">
          <Link href="#authentication" className="directory-link">
            Authentication
          </Link>
        </div>
      </div>
    </div>
  );
};

interface Props {
  isEnterpriseAdmin: boolean;
}

export default React.memo(Password);
